import styled, { css } from 'styled-components';

export const ocAnchorStyle = css`
  pointer-events: all;
  color: ${({ theme }) => theme.colorPrimary};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colorPrimary};
    text-decoration: underline;
  }
  &:focus {
    color: ${({ theme }) => theme.colorPrimary};
    text-decoration: underline;
  }
`;

const StyledOcAnchor = styled.a`
  ${ocAnchorStyle}
`;
export default StyledOcAnchor;

StyledOcAnchor.displayName = 'StyledOcAnchor';
